'use client';

import Link from 'next/link';
import React, { useMemo } from 'react';
import { ApiRoutes, Routes } from '@/settings/routes';
import { App_text } from '@/settings/AppText';
import { IoTimeOutline } from 'react-icons/io5';
import { IoIosArrowForward } from 'react-icons/io';

export default function CardCityBreak({ data = {} }) {
    const calculateDiscount = useMemo(() => {
        if (data?.has_promo && data?.price && data?.price_promo) {
            const discount = ((data?.price - data?.price_promo) / data?.price) * 100;
            return discount.toFixed();
        }
        return 0;
    }, [data?.has_promo, data?.price, data?.price_promo]);

    const image = useMemo(() => (data?.thumbnail?.url ? ApiRoutes.ASSETS_ENDPOINT + data?.thumbnail?.url : '/media/tour-06.jpg'), [data?.thumbnail?.url]);

    const createMarkup = (htmlContent) => {
        return { __html: htmlContent };
    };

    const truncateText = (html, maxLength = 90) => {
        if (!html) return '';

        // Create a temporary div
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const plainText = tempDiv.textContent || tempDiv.innerText;

        // If text is shorter than maxLength, return original HTML
        if (plainText.length <= maxLength) return html;

        // Find last space within maxLength
        const lastSpace = plainText.substring(0, maxLength).lastIndexOf(' ');
        const truncLength = lastSpace === -1 ? maxLength : lastSpace;

        const truncatedText = plainText.substring(0, truncLength) + '...';

        return truncatedText;
    };

    return (
        <div className="flex overflow-hidden relative flex-col h-full bg-white rounded-lg shadow-md transition-all duration-500 hover:shadow-xl group">
            {/* Decorative top accent bar */}
            <div className="absolute top-0 left-0 right-0 z-10 h-1 transition-transform origin-left duration-500 transform bg-main-color scale-x-[30%] group-hover:scale-x-100"></div>

            {/* Image container with enhanced hover effects */}
            <div className="overflow-hidden relative">
                <Link prefetch={false} href={`${Routes.FRONT_city_break + data?.slug}`} className="block">
                    <div className="relative overflow-hidden aspect-[4/3]">
                        <img
                            className="object-cover absolute inset-0 w-full h-full transition-all duration-700 transform ease-out-cubic group-hover:scale-110"
                            src={image}
                            alt={data?.title || 'City Break'}
                            width={800}
                            height={600}
                            loading="lazy"
                        />

                        {/* Stylish gradient overlay */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-60"></div>

                        {/* Interactive hover ripple effect */}
                        <div className="absolute inset-0 pointer-events-none">
                            <span className="absolute inset-0 w-full h-full bg-white rounded-full opacity-10 transform scale-0 -translate-x-full -translate-y-full group-hover:animate-ripple"></span>
                        </div>
                    </div>

                    {/* Duration badge with animation */}
                    {/* <div className="absolute z-10 flex items-center px-3 py-1.5 text-white bottom-5 left-5 backdrop-blur-sm bg-black/50 rounded-full overflow-hidden transition-all duration-300 group-hover:bg-main-color/90">
                        <IoTimeOutline className="mr-1.5 transition-transform duration-300 group-hover:rotate-12" />
                        <span className="text-sm font-medium">{data.duration}</span>
                    </div> */}
                </Link>

                {/* Animated discount badge */}
                {/* {calculateDiscount > 0 && (
                    <div className="absolute top-5 right-5 z-10">
                        <div className="flex relative justify-center items-center w-16 h-16 text-white rounded-full bg-main-color">
                       
                            <span className="absolute inset-0 rounded-full bg-main-color/20 animate-ping-slow"></span>
                            <div className="flex flex-col items-center">
                                <span className="text-2xl font-bold leading-none">{calculateDiscount}%</span>
                                <span className="text-xs font-medium">OFF</span>
                            </div>
                        </div>
                    </div>
                )} */}
            </div>

            {/* Content area with decorative elements */}
            <div className="flex relative flex-col flex-grow p-5">
                {/* Decorative corner accents that appear on hover */}
                <div className="absolute top-0 left-0 w-10 h-10 rounded-tl-md border-t-2 border-l-2 transition-all duration-500 border-main-color/0 group-hover:border-main-color/20"></div>
                <div className="absolute right-0 bottom-0 w-10 h-10 rounded-br-md border-r-2 border-b-2 transition-all duration-500 border-main-color/0 group-hover:border-main-color/20"></div>

                <Link prefetch={false} href={`${Routes.FRONT_city_break + data?.slug}`} className="block group/title">
                    <h3 className="mb-3 text-xl font-semibold transition-colors duration-300 text-neutral-800 group-hover/title:text-main-color leading-normal">{data?.title}</h3>
                </Link>

                {data?.description && (
                    <div className="flex-grow mb-4">
                        <p className="text-neutral-600" dangerouslySetInnerHTML={createMarkup(truncateText(data.description))} />
                    </div>
                )}

                {/* Pricing section with enhanced styling */}
                <div className="pt-3 mt-auto border-t border-neutral-100">
                    <div className="flex items-end">
                        {/* <div>
                            <div className="mb-1 text-sm text-neutral-500">{App_text.card_tour.price}</div>
                            {data?.price !== null && data?.price !== 0 && data?.price !== '0.00' ? (
                                data?.has_promo === 1 ? (
                                    <div className="flex items-baseline">
                                        <span className="text-2xl font-bold transition-all duration-300 text-main-color group-hover:scale-105">
                                            {data?.price_promo}
                                            {App_text.generale.currancy}
                                        </span>
                                        <span className="ml-2 text-sm line-through text-neutral-400">
                                            {data?.price}
                                            {App_text.generale.currancy}
                                        </span>
                                        <span className="ml-1 text-xs text-neutral-500">/pers</span>
                                    </div>
                                ) : (
                                    <div className="flex items-baseline">
                                        <span className="text-2xl font-bold transition-all duration-300 text-main-color group-hover:scale-105">
                                            {data?.price}
                                            {App_text.generale.currancy}
                                        </span>
                                        <span className="ml-1 text-xs text-neutral-500">/pers</span>
                                    </div>
                                )
                            ) : (
                                <div className="text-xl font-bold text-main-color">Price on request</div>
                            )}
                        </div> */}

                        {/* Animated view details button */}
                        <div className="relative w-full group/btn">
                            <Link
                                prefetch={false}
                                href={`${Routes.FRONT_city_break + data?.slug}`}
                                className="flex justify-between items-center"
                                aria-label={`View details for ${data?.title || 'this city break'}`}
                                role="button"
                            >
                                <span className="text-sm font-semibold underline opacity-70 hover:opacity-100">{App_text.card_package.text_action}</span>
                                <spna className="flex justify-center items-center ml-2 w-10 h-10 text-white rounded-full transition-all duration-300 bg-main-color/80 group-hover/btn:bg-main-color focus:outline-none focus:ring-2 focus:ring-main-color focus:ring-offset-2">
                                    <IoIosArrowForward className="transition-transform duration-300 group-hover/btn:translate-x-0.5" aria-hidden="true" />
                                </spna>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
